import { Component } from '@angular/core';
import { BalanceQuery, config, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-balance-widgets',
  templateUrl: './balance-widgets.component.html',
  styleUrl: './balance-widgets.component.scss',
})
export class BalanceWidgetsComponent {
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;
  population = Populations;
  isKid: boolean;

  constructor(private balanceQuery: BalanceQuery, private populationQuery: PopulationQuery) {}

  ngOnInit() {
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }

}
